<template>
<div class="subjectList padding-20 bgc box-shadow">
    <div class="top_handle_box">
        <div>
            <el-button @click="handleAdd" type="primary">新建题库</el-button>
            <el-button @click="handleAddSpecial" type="primary" v-if="user.isofficalhost==1">专题题库管理</el-button>
        </div>
        <div>
            <div style="width: 108px;">
                <el-select v-model="questionStatusValue" placeholder="全部状态">
                    <el-option v-for="item in questionStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <div style="width: 220px;">
                <el-input v-model="questionBankName" placeholder="请输入题库名称"></el-input>
            </div>
            <el-button @click="handleQuery" type="primary" plain>搜索</el-button>
        </div>
    </div>
    <div class="subject_table_box">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column label="题库名称" width="360" align="center">
                <template slot-scope="scope">
                    <div class="subject_info_box">
                        <img v-lazy="scope.row.coverurl" alt="">
                        <div>
                            <p>{{scope.row.subject}}</p>
                            <p>
                                <span v-if="scope.row.ispublic === 0">不公开</span>
                                <span v-if="scope.row.qbtype === 1">单试卷</span>
                                <span v-else>系列试卷</span>
                                <span v-if="scope.row.feetype === 1">{{scope.row.feetypetext}}</span>
                                <span v-else>￥{{scope.row.saleprice}}</span>
                            </p>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="ordercount" label="订购量" align="center"></el-table-column>
            <el-table-column prop="viewcount" label="访问量 " align="center"></el-table-column>
            <el-table-column label="上架状态 " align="center">
                <template slot-scope="scope"><span :class="statusTextClass(scope.row.statustext)">{{scope.row.statustext}}</span></template>
            </el-table-column>
            <el-table-column prop="datetime" label="发布时间" align="center" min-width="170"></el-table-column>
            <el-table-column label="操作" align="right" width="350">
                <template slot-scope="scope">
                    <div class="table_handle_box">
                        <span v-if="scope.row.status !== 100" class="span_text" @click="jumpPage(scope.row, 'SubjectEdit')">编辑</span>
                        <span v-if="scope.row.status !== 100"> &nbsp;|&nbsp; </span>

                        <span v-if="scope.row.qbtype === 2 && scope.row.status !== 100" class="span_text" @click="jumpPage(scope.row, 'SubjectChapterSetUp')">章节设置</span>
                        <span v-if="scope.row.qbtype === 2 && scope.row.status !== 100"> &nbsp;|&nbsp; </span>

                        <span class="span_text" @click="jumpPage(scope.row, 'SubjectTestpaperMarking')">考试列表</span>

                        <span v-if="scope.row.feetype === 2"> &nbsp;|&nbsp; </span>
                        <span v-if="scope.row.feetype === 2" class="span_text" @click="toOrder(scope.row)">订单</span>

                        <!-- <span v-if="scope.row.status !== 100"> &nbsp;|&nbsp; </span>
                        <span v-if="scope.row.status === 30" class="span_text" @click="isPutaway(scope.row, '下架')">下架</span>
                        <span v-if="scope.row.status === 10 || scope.row.status === 31" class="span_text" @click="isPutaway(scope.row, '上架')">上架</span>

                        <span v-if="scope.row.status !== 100"> &nbsp;|&nbsp; </span>
                        <span v-if="scope.row.status !== 100" class="span_text" @click="delClick(scope.row)">删除</span> -->
                        <span> &nbsp;|&nbsp; </span>
                        <!-- <span class="span_text" @click="handCopy(scope.row)">复制题库</span> -->
                        <el-dropdown>
                            <span class="el-dropdown-link separator">
                                更多
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="goSubjectData(scope.row)">题库资料</el-dropdown-item>
                                <el-dropdown-item @click.native="setCertificate(scope.row)" v-if="!scope.row.isopencert">设置证书</el-dropdown-item>
                                <el-dropdown-item @click.native="editCertificate(scope.row)" v-if="scope.row.isopencert">编辑证书</el-dropdown-item>
                                <el-dropdown-item @click.native="closeCertificate(scope.row)" v-if="scope.row.isopencert">关闭证书</el-dropdown-item>
                                <el-dropdown-item v-if="scope.row.status === 30" @click.native="isPutaway(scope.row, '下架')">下架</el-dropdown-item>
                                <el-dropdown-item v-if="scope.row.status === 10 || scope.row.status === 31" @click.native="isPutaway(scope.row, '上架')">上架</el-dropdown-item>
                                <el-dropdown-item v-if="scope.row.status !== 100" @click.native="delClick(scope.row, '上架')">删除</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" @getList="_getList" ref="page"></page>
    </div>
</div>
</template>

<script>
import {getAllQuestionbankInfo, updateQuestionbankStatus, copyQuestionInfo} from 'api/questionApi'
import {deleteCertInfo} from 'api/operateToolApi'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'subjectList',
    data() {
        return {
            total: 0,
            tableData: [],
            questionBankName: '',
            questionStatusValue: '',
            questionStatusOptions: [
                {
                    value: '',
                    label: '全部状态'
                },
                {
                    value: '30',
                    label: '已上架'
                },
                {
                    value: '31',
                    label: '已下架'
                },
                {
                    value: '10',
                    label: '待上架'
                },
                {
                    value: '100',
                    label: '已删除'
                }
            ]
        }
    },
    mounted() {
        this._getList()
    },
    methods: {
        handleAddSpecial() {
            this.$router.push({
                name: 'SpecialList',
                query: {}
            })
        },
        // 设置证书
        setCertificate(item) {
            this.$router.push({
                name: 'certificateEdit',
                query: {
                    kmcinnerid: item.innerid,
                    kmctype: 8
                }
            })
        },
        // 编辑证书
        editCertificate(item) {
            this.$router.push({
                name: 'certificateEdit',
                query: {
                    innerid: item.certconfigid
                }
            })
        },
        // 跳转至题库资料
        goSubjectData(data){
            this.$router.push({name: 'SubjectData',query: {innerid: data.innerid}})
        },
        closeCertificate(item) {
            this.$confirm('关闭后将无法恢复，确认关闭证书吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.setLoading(true)
                deleteCertInfo({
                    data: {certinnerid: item.certconfigid},
                    success: res => {
                        this.setLoading(false)
                        item.isopencert = 0
                        console.log(res)
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$message.error(res.msg)
                    }
                })
            }).catch(() => {
                // 取消删除
            })
        },
        // 复制题库
        handCopy(row) {
            this.setLoading(true)
            copyQuestionInfo({
                data: {innerid: row.innerid},
                success: res => {
                    this.setPage({page: 1, pageSize: 10})
                    this.$refs.page.pagination = {page: 1, pageSize: 10}
                    this._getList()
                    this.$message.success('复制成功')
                    this.setLoading(false)
                },
                error: res => {
                    this.$message.error(res.msg)
                    this.setLoading(false)
                }
            })
        },
        // 页面路由跳转
        jumpPage(row, val) {
            // console.log(row)
            // console.log(val)
            this.$router.push({name: val, query: {qid: row.innerid}})
        },
        // 跳转到交易中心 下 订单管理
        toOrder(row) {
            // console.log(row)
            this.$router.push({name: 'Order', query: {kmctype: 8, kmcinnerid: row.innerid}})
        },
        // 删除题库
        delClick(row) {
            this.$confirm('删除后不可恢复，是否确定删除该题库？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                // console.log(row)
                // 确定删除
                this.updateQuestionbankStatusFn(row.innerid, 100)

            }).catch(() => {
                // 取消删除
            })
        },
        // 题库: 上架 or 下架
        isPutaway(row, type) {
            if(type === '上架') {
                // 上架
                this.updateQuestionbankStatusFn(row.innerid, 30)
            } else {
                // 下架
                this.updateQuestionbankStatusFn(row.innerid, 31)
            }
        },
        // 修改题库状态
        updateQuestionbankStatusFn(id, statusValue) {
            this.setLoading(true)
            var params = {
                innerid: id,
                status: statusValue
            }
            updateQuestionbankStatus({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.$message.success('操作成功！')
                    this._getList()
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 查询题库列表
        _getList() {
            this.setLoading(true)
            var params = {
                subject: this.questionBankName, // 题库名称
                status: this.questionStatusValue, // 题库上架状态：0或者空 全部   1已上架     2已下架     3待上架
                page: this.page.page,
                pagesize: this.page.pageSize,
            }
            getAllQuestionbankInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        // 题库上架状态字体颜色
        statusTextClass(val) {
            if(val === '待上架') {
                return 'yellow_text'
            } else if(val === '已上架') {
                return 'green_text'
            } else {
                return 'gray_text'
            }
        },
        // 新建题库按钮
        handleAdd() {
            // console.log(this.shop)
            if (this.shop.authstatus === 0) {
                this.$confirm('该功能需要在开通企业版或者单独工具基础上方可使用，建议尽快购买，购买后可继续使用该功能', '提示', {
                    confirmButtonText: '去购买',
                    cancelButtonText: '取消'
                }).then(() => {
                    // 去购买
                    this.$router.push({name: 'OrderService'})
                }).catch(() => {
                    // 取消
                })
            } else {
                this.$router.push({name: 'SubjectEdit'})
            }
        },
        ...mapActions([
            'setLoading',
            'setPage'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page',
            'shop',
            'user'
        ])
    },
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss" scope>
    .subjectList {
        padding-bottom: 30px;
        .top_handle_box {
            display: flex;
            justify-content: space-between;
            &>div:nth-of-type(2){
                display: flex;
                .el-input__icon {
                    line-height: 0px;
                }
                &>div {
                    margin-right: 20px;
                }
            }
        }
        .subject_table_box{
            margin-top: 30px;
            .el-table th>.cell {
                font-weight: bold!important;
            }
            .el-table__empty-block {
                min-height: 360px;
            }
            .el-table__empty-text {
                box-sizing: border-box;
                line-height: 0px;
                padding-top: 150px;
            }
            .subject_info_box {
                display: flex;
                img{
                    min-width: 106px;
                    width: 106px;
                    height: 60px;
                    margin-right: 10px;
                }
                &>div{
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    p{
                        text-align: left;
                        line-height: 18px;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                        span{
                            color: #F56C6C;
                            margin-right: 10px;
                            font-size: 12px;
                        }
                        span:nth-last-of-type(1){
                            margin-right: 0;
                        }
                    }
                }
            }
            .table_handle_box {
                span{
                    color: #439FFE;
                    cursor: pointer;
                    font-size: 12px;
                }
                .span_text:hover{
                    color: rgb(8, 125, 243);
                }
            }
            .green_text {
                color: #67C23A;
            }
            .yellow_text {
                color: #E6A23C;
            }
            .gray_text {
                color: #606266;
            }
        }
    }
</style>
